module.exports = __webpack_public_path__ + "static/media/additem.c901babf.svg";